var messageType = /* @__PURE__ */ ((messageType2) => {
  messageType2["CUSTOM"] = "CUSTOM_MESSAGE";
  messageType2["PMT"] = "PMT_MESSAGE";
  messageType2["PRICES"] = "PRICE_MESSAGE";
  return messageType2;
})(messageType || {});
var CouponType = /* @__PURE__ */ ((CouponType2) => {
  CouponType2["Cart"] = "Cart";
  CouponType2["Product"] = "Product";
  return CouponType2;
})(CouponType || {});

export { CouponType, messageType };
//# sourceMappingURL=src-clients-couponCallout.client.types.js.map
